module.exports = __webpack_public_path__ + "static/media/dekor.e7c9f0b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dekor.png
// module id = 312
// module chunks = 0